const genders = [
    "Aunty",
    "Uncle"
]
export default genders